// cropperImage.js
import React, { useState, useCallback, forwardRef, useImperativeHandle } from "react";
import Cropper from "react-easy-crop";

const CropperImage = forwardRef(({ image }, ref) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const zoom = 1; // constant, non-updatable

  useImperativeHandle(ref, () => ({
    async getCroppedImage() {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels);
      return croppedImage;
    }
  }));

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        width: 300,
        height: 300,
        marginTop: 20,
        overflow: "hidden",
        touchAction: "none", // blocks pinch
      }}
      onWheel={(e) => e.preventDefault()} // blocks scroll
      onTouchMove={(e) => {
        if (e.touches.length > 1) e.preventDefault(); // blocks pinch
      }}
    >
      <Cropper
        image={image}
        crop={crop}
        zoom={zoom}
        zoomWithScroll={false}
        restrictPosition={true}
        aspect={1}
        cropShape="round"
        showGrid={false}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={() => {}} // override but do nothing
      />
    </div>
  );
});

export default CropperImage;

const getCroppedImg = (imageSrc, pixelCrop) => {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      resolve(canvas.toDataURL("image/png"));
    };
    image.src = imageSrc;
  });
};
